import { render, staticRenderFns } from "./SimpleOrderSummary.vue?vue&type=template&id=3278a9f6&scoped=true&"
import script from "./SimpleOrderSummary.vue?vue&type=script&lang=js&"
export * from "./SimpleOrderSummary.vue?vue&type=script&lang=js&"
import style0 from "./SimpleOrderSummary.vue?vue&type=style&index=0&id=3278a9f6&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3278a9f6",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
installComponents(component, {VBtn})
